import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import { ROLE } from '../../../_helpers/exports';

class SidebarContent extends Component {
  static propTypes = {
    changeToDark: PropTypes.func.isRequired,
    changeToLight: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  hideSidebar = () => {
    const { onClick } = this.props;
    onClick();
  };
  logout = () => {
    window.location.href = "/log_in";

    localStorage.removeItem('token');
  }

  logoutagent = () => {
    window.location.href = "/log_in";

    localStorage.removeItem('token');
  }

  render() {
    const { changeToLight, changeToDark } = this.props;

    return (
      <div className="sidebar__content">
        <>

          <ul className="sidebar__block">
            <SidebarLink
              title="Deposits"
              icon="briefcase"
              route="/deposit"
              onClick={this.hideSidebar}
            />
          </ul>
          <ul className="sidebar__block">
            <SidebarLink title="Log Out" icon="exit" onClick={this.logout}
              route="/login_in" />
          </ul>
        </>
      </div>
    );
  }
}

export default SidebarContent;
